import { useCallback, useEffect, useState } from 'react';

/**
 * Determines if the current browser tab is visible or not
 * by tracking the visibility state of a document.
 * @returns Boolean
 */
const useIsBrowserTabActive = () => {
  const [visibilityState, setVisibilityState] = useState(true);

  const handleVisibilityChange = useCallback(() => {
    setVisibilityState(document.visibilityState === 'visible');
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return visibilityState;
};

export default useIsBrowserTabActive;
